export enum OrderStatusEnum
{
    New = 'New',
    PaymentPending = 'PaymentPending',
    Paid = 'Paid',
    InProgress = 'InProgress',
    AwaitingShipment = 'AwaitingShipment',
    Sent = 'Sent',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

export const OrderStatusOptions = () => ([
    { value: OrderStatusEnum.New, text: $t('[[[Nowe]]]') },
    { value: OrderStatusEnum.PaymentPending, text: $t('[[[Oczekuje na płatność]]]') },
    { value: OrderStatusEnum.Paid, text: $t('[[[Opłacone]]]') },
    { value: OrderStatusEnum.InProgress, text: $t('[[[W trakcie realizacji]]]') },
    { value: OrderStatusEnum.AwaitingShipment, text: $t('[[[Oczekuje na wysłanie]]]') },
    { value: OrderStatusEnum.Sent, text: $t('[[[Wysłane]]]') },
    { value: OrderStatusEnum.Completed, text: $t('[[[Zrealizowane]]]') },
    { value: OrderStatusEnum.Cancelled, text: $t('[[[Anulowane]]]') }
]);

export const OrderStatusName = (value: OrderStatusEnum) => OrderStatusOptions().find(p => p.value === value)?.text || OrderStatusEnum[value];


// ----------------------------------------------------------------------------------------------------

export enum StorePeriodEnum
{
    Last24Hours = 'Last24Hours',
    Last7Days = 'Last7Days',
    Last30Days = 'Last30Days',
    Last90Days = 'Last90Days',
    Yearly = 'Yearly',
    CustomRange = 'CustomRange'
}

export const StorePeriodOptions = (): Option[] => ([
    { value: StorePeriodEnum.Last24Hours, text: $t('[[[Ostatnie 24h]]]') },
    { value: StorePeriodEnum.Last7Days, text: $t('[[[Ostatnie 7 dni]]]') },
    { value: StorePeriodEnum.Last30Days, text: $t('[[[Ostatni miesiąc]]]') },
    { value: StorePeriodEnum.Last90Days, text: $t('[[[Ostatnie 90 dni]]]') },
    { value: StorePeriodEnum.Yearly, text: $t('[[[Ostatni rok]]]') },
    { value: StorePeriodEnum.CustomRange, text: $t('[[[Własny przedział]]]') }
]);

export const StorePeriodName = (value: StorePeriodEnum): string => StorePeriodOptions().find(p => p.value === value)?.text || StorePeriodEnum[value];
